// test285
(285 && 0);
